// extracted by mini-css-extract-plugin
export default {"melodyVideo":"GJ-z","isFullWidth":"HJ-z","landingPageVideo":"IJ-z","play":"JJ-z","iframeVideo":"KJ-z","playHidden":"LJ-z","fullwidth":"MJ-z"};